import {useQuery} from "@tanstack/react-query";
import {PcsSearchParamType} from "../interface";
import {readPurchaseOrderList} from "../../../../../api/purchase/PcsApi";
import {pcsListMapInit} from "../state";

type Props = {
    param: PcsSearchParamType;
    enabled?: boolean
};

export const useReadPurchaseOrderList = ({param, enabled}: Props) => {
    const {data} = useQuery({
        queryKey: ["readPurchaseOrderList", param],
        queryFn: async () => await readPurchaseOrderList(param),
        select: (res) => res?.data.result ?? pcsListMapInit,
        enabled: !!enabled
    });

    return {data};
};
